// extracted by mini-css-extract-plugin
export default {"versionContainer":"Version_versionContainer__dLqqp"};